export const CC = {
  ink: "#05204C",
  inkMuted: "#5C6B80",
  inkSoft: "rgba(5, 32, 76, 0.62)",
  canvas: "#EFECE4",
  paper: "#FFFCF7",
  paperRaised: "#FFFFFF",
  line: "rgba(5, 32, 76, 0.10)",
  lineStrong: "rgba(5, 32, 76, 0.16)",
  accent: "#0E8AA8",
  accentSoft: "rgba(14, 138, 168, 0.12)",
  gold: "#A57C32",
  goldSoft: "rgba(165, 124, 50, 0.12)",
  distress: "#B42318",
  distressSoft: "#FDF2F0",
  success: "#1B7A4A",
  successSoft: "rgba(27, 122, 74, 0.12)",
  navyGlow: "rgba(14, 138, 168, 0.22)",
  radius: 20,
  radiusSm: 12,
  radiusXs: 8,
  shadow: "0 1px 2px rgba(5, 32, 76, 0.04), 0 18px 40px rgba(5, 32, 76, 0.07)",
  shadowSoft: "0 1px 2px rgba(5, 32, 76, 0.04)",
  font: "Rubik, sans-serif",
} as const;

export const ccFieldSx = {
  "& .MuiOutlinedInput-root": {
    bgcolor: CC.paperRaised,
    borderRadius: `${CC.radiusSm}px`,
    fontFamily: CC.font,
    "& fieldset": { borderColor: CC.line },
    "&:hover fieldset": { borderColor: CC.lineStrong },
    "&.Mui-focused fieldset": { borderColor: CC.ink, borderWidth: "1px" },
  },
  "& .MuiInputLabel-root": {
    fontFamily: CC.font,
    color: CC.inkMuted,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: CC.ink,
  },
} as const;

export const ccPrimaryButtonSx = {
  fontFamily: CC.font,
  fontWeight: 600,
  letterSpacing: "0.01em",
  textTransform: "none" as const,
  borderRadius: `${CC.radiusSm}px`,
  px: 2.5,
  py: 1.15,
  bgcolor: CC.ink,
  color: CC.paper,
  boxShadow: "none",
  "&:hover": { bgcolor: "#0A2E63", boxShadow: "none" },
  "&.Mui-disabled": { bgcolor: "rgba(5,32,76,0.18)", color: CC.paper },
};

export const ccGhostButtonSx = {
  fontFamily: CC.font,
  fontWeight: 600,
  textTransform: "none" as const,
  borderRadius: `${CC.radiusSm}px`,
  px: 2,
  py: 1.05,
  color: CC.ink,
  borderColor: CC.lineStrong,
  bgcolor: "transparent",
  "&:hover": { bgcolor: "rgba(5,32,76,0.04)", borderColor: CC.ink },
  "&.Mui-disabled": { borderColor: CC.line, color: CC.inkMuted },
};

export const ccSoftButtonSx = {
  fontFamily: CC.font,
  fontWeight: 600,
  textTransform: "none" as const,
  borderRadius: `${CC.radiusSm}px`,
  px: 2,
  py: 1.05,
  color: CC.ink,
  bgcolor: "rgba(5,32,76,0.05)",
  boxShadow: "none",
  "&:hover": { bgcolor: "rgba(5,32,76,0.09)", boxShadow: "none" },
};

export const ccDangerButtonSx = {
  fontFamily: CC.font,
  fontWeight: 700,
  textTransform: "none" as const,
  borderRadius: `${CC.radiusSm}px`,
  px: 2,
  py: 1.05,
  bgcolor: CC.distress,
  color: "#fff",
  boxShadow: "none",
  "&:hover": { bgcolor: "#8F1D16", boxShadow: "none" },
};

export const ccDialogPaperSx = {
  borderRadius: `${CC.radius}px`,
  bgcolor: CC.paper,
  boxShadow: CC.shadow,
  backgroundImage: "none",
  p: 0.5,
};

export const navyStageSx = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: { xs: 2.5, md: 4 },
  fontFamily: CC.font,
  background: `
    radial-gradient(1000px 520px at 88% -8%, ${CC.navyGlow}, transparent 58%),
    radial-gradient(720px 420px at 0% 110%, rgba(255,255,255,0.08), transparent 52%),
    ${CC.ink}
  `,
} as const;
